import { startOfYear, startOfMonth, subDays, isEqual } from 'owa-datetime';
import { observableToday } from 'owa-observable-datetime';
import { getStore } from '../store/store';
import {
    getStartOfWeek,
    getEndOfLastWeek,
    getStartOfLastWeek,
    getEndOfLastMonth,
    getStartOfLastMonth,
    getEndOfLastYear,
    getStartOfLastYear,
} from '../utils/dateRangeUtils';

export default function getTimeFilterDropdownValue(): string {
    const { fromDate, toDate } = getStore();

    if (!fromDate && !toDate) {
        return null;
    }

    // User has set a single from or to date from advanced search
    if (!fromDate || !toDate) {
        return 'custom';
    }

    const todayDate = observableToday();
    const yesterday = subDays(todayDate, 1);

    if (isEqual(toDate, todayDate)) {
        if (isEqual(fromDate, todayDate)) {
            return 'today';
        } else if (isEqual(fromDate, getStartOfWeek(todayDate))) {
            return 'thisweek';
        } else if (isEqual(fromDate, startOfMonth(todayDate))) {
            return 'thismonth';
        } else if (isEqual(fromDate, startOfYear(todayDate))) {
            return 'thisyear';
        } else {
            return 'custom';
        }
    } else if (isEqual(toDate, yesterday) && isEqual(fromDate, yesterday)) {
        return 'yesterday';
    } else if (
        isEqual(toDate, getEndOfLastWeek(todayDate)) &&
        isEqual(fromDate, getStartOfLastWeek(todayDate))
    ) {
        return 'lastweek';
    } else if (
        isEqual(toDate, getEndOfLastMonth(todayDate)) &&
        isEqual(fromDate, getStartOfLastMonth(todayDate))
    ) {
        return 'lastmonth';
    } else if (
        isEqual(toDate, getEndOfLastYear(todayDate)) &&
        isEqual(fromDate, getStartOfLastYear(todayDate))
    ) {
        return 'lastyear';
    } else {
        return 'custom';
    }
}
